import React from "react";
import { ProviderConsumer } from "@fluentui/react-northstar";
import { Helmet } from 'react-helmet';
import { useTranslation } from "react-i18next";
import { checkInTeams } from "../../App";
import RequestContextProvider from "./RequestList/RequestContextProvider";
import { Nav } from '../../browser-pages/browser-components/Nav';
import CreateRequest from "./CreateRequest";

export const CreateCatalogRequest = () => {
  const { t } = useTranslation();
  
  return (<ProviderConsumer render={globalTheme => (<>
    <Helmet>
      <title>{t('ticket.toolbar.tickets')} - Tikit</title>
    </Helmet>
    <RequestContextProvider>
      {!checkInTeams() && <Nav />}
      <CreateRequest fromCatalog={true} />
    </RequestContextProvider>
  </>)} />);
};